import { useEffect, useState } from "react";
import exportimages from "../../../assets/images/exportImages";
import "./Notification.scss";
import { USER_NOTIFICATION_AARAY } from "../../../utils/global";
import {
  useGetNotificationListQuery,
  useReadAllNotificationListMutation,
} from "../../../rtk-query/features/usernotification/notificationSlice";
const Notification = ({ LogoutHandler }) => {
  const { data, isLoading } = useGetNotificationListQuery();
  const notificationList = data?.data;
  const [enableReadAll, setEnableReadAll] = useState(false);
  useEffect(() => {
    setEnableReadAll(
      notificationList?.every(
        (item) => item.readAt !== null && item.readAt !== undefined,
      ),
    );
  }, [notificationList]);

  const newDataNotification = notificationList
    ?.filter((n) => n.notifiableType === "New Data Available")
    ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))[0];

  const [readAllNotifications] = useReadAllNotificationListMutation();

  const readAllnotification = async () => {
    const payloadObject = {
      ...notificationList[0],
      markAllAsRead: true,
    };
    readAllNotifications({
      payloadObject,
    });
  };

  return (
    <>
      <div className="notificationPanel">
        <div class="d-flex bd-highlight headerBlock">
          <div class="me-auto bd-highlight">
            <label>Notifications</label>
          </div>
          <div class="bd-highlight">
            <button
              type="button"
              class="btn btn-link py-0"
              onClick={() => {
                readAllnotification();
              }}
              disabled={
                !notificationList ||
                notificationList.length === 0 ||
                enableReadAll
              }
            >
              Mark as read
            </button>
          </div>
        </div>
        <div
          className={`${notificationList?.length > 0 ? "scrollToNotificationPanel" : ""}`}
        >
          {notificationList?.length > 0 ? (
            <>
              {notificationList.map((notification) => {
                const matchedIcon = USER_NOTIFICATION_AARAY.find(
                  (item) => item.key === notification?.notifiableType,
                )?.img;
                return (
                  <div class="d-flex singleBlock">
                    <div class="flex-shrink-0">
                      <img
                        src={
                          matchedIcon
                            ? matchedIcon
                            : exportimages?.icon_notification_default
                        }
                        alt={notification?.notifiableType}
                      />
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex bd-highlight align-items-center">
                        <div class="me-auto bd-highlight">
                          <label>{notification?.notifiableType}</label>
                        </div>
                        <div class="bd-highlight notificationDate">
                          <label>
                            {new Date(notification?.createdOn).toLocaleString(
                              "en-US",
                              {
                                month: "short",
                                day: "numeric",
                              },
                            )}
                          </label>
                        </div>
                        <div
                          class="bd-highlight newNotificationIndicator"
                          style={{
                            display: notification?.readAt ? "none" : "block",
                          }}
                        ></div>
                      </div>
                      <div className="notificationContent">
                        <p className="mb-0">{notification?.data}</p>
                        {notification?.id === newDataNotification?.id && (
                          <button
                            type="button"
                            className="btn btn-link py-0"
                            style={{ marginTop: "0.462rem" }}
                            onClick={LogoutHandler}
                          >
                            Logout{" "}
                            <span>
                              <img
                                src={exportimages?.notification_right_arrow}
                                style={{
                                  width: "0.769rem",
                                  marginLeft: "0.846rem",
                                }}
                              />
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <p>No notifications available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Notification;
